<template>
    <div class="create-newsfeed-container">
        <newsfeed-form
            title="Create Newsfeed"
            @cancel="$router.push('/newsfeed-post')"
            @draft="$router.push('/newsfeed-post')"
            @publish="$router.push('/newsfeed-post')"
        ></newsfeed-form>
    </div>
</template>

<script>
import NewsfeedForm from '@/components/newsfeed/NewsfeedForm.vue'

export default {
	components: {
		NewsfeedForm
	}
}
</script>
